import React, { useEffect, useState } from 'react';
import API from './api';

function AdminDocuments() {
  const [tab, setTab] = useState('general');

  const [generalDocs, setGeneralDocs] = useState([]);

  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState('');
  const [studentDocs, setStudentDocs] = useState([]);

  const [teachers, setTeachers] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState('');
  const [teacherDocs, setTeacherDocs] = useState([]);

  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    fetchGeneral();
    fetchStudents();
    fetchTeachers();
  }, []);

  const fetchGeneral = async () => {
    const res = await API.get('/documents/general');
    setGeneralDocs(res.data || []);
  };
  const fetchStudents = async () => {
    const res = await API.get('/students');
    setStudents(res.data || []);
  };
  const fetchTeachers = async () => {
    const res = await API.get('/teachers');
    setTeachers(res.data || []);
  };
  const fetchStudentDocs = async (id) => {
    if (!id) return setStudentDocs([]);
    const res = await API.get(`/documents/student/${id}`);
    setStudentDocs(res.data || []);
  };
  const fetchTeacherDocs = async (id) => {
    if (!id) return setTeacherDocs([]);
    const res = await API.get(`/documents/teacher/${id}`);
    setTeacherDocs(res.data || []);
  };

  // Download sa JWT
  const handleDownload = async (docId, filename) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`/api/documents/download/${docId}`, {
        headers: { Authorization: token }
      });
      if (!res.ok) throw new Error('Failed to download file');
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename || 'file';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      alert('Download failed!');
    }
  };

  // GENERAL upload/delete
  const handleGeneralUpload = async e => {
    e.preventDefault();
    setUploading(true);
    const form = new FormData(e.target);
    await API.post('/documents/general', form, { headers: { 'Content-Type': 'multipart/form-data' } });
    e.target.reset();
    setUploading(false);
    fetchGeneral();
  };
  const handleGeneralDelete = async id => {
    if (window.confirm('Delete?')) {
      await API.delete(`/documents/general/${id}`);
      fetchGeneral();
    }
  };

  // STUDENT upload/delete
  const handleStudentUpload = async e => {
    e.preventDefault();
    if (!selectedStudent) return alert('Select student!');
    setUploading(true);
    const form = new FormData(e.target);
    await API.post(`/documents/student/${selectedStudent}`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
    e.target.reset();
    setUploading(false);
    fetchStudentDocs(selectedStudent);
  };
  const handleStudentDelete = async (sid, id) => {
    if (window.confirm('Delete?')) {
      await API.delete(`/documents/student/${sid}/${id}`);
      fetchStudentDocs(sid);
    }
  };

  // TEACHER upload/delete
  const handleTeacherUpload = async e => {
    e.preventDefault();
    if (!selectedTeacher) return alert('Select teacher!');
    setUploading(true);
    const form = new FormData(e.target);
    await API.post(`/documents/teacher/${selectedTeacher}`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
    e.target.reset();
    setUploading(false);
    fetchTeacherDocs(selectedTeacher);
  };
  const handleTeacherDelete = async (tid, id) => {
    if (window.confirm('Delete?')) {
      await API.delete(`/documents/teacher/${tid}/${id}`);
      fetchTeacherDocs(tid);
    }
  };
  
  const fmtDate = (v) => (v ? String(v).replace('T', ' ').slice(0, 16) : '');

  return (
    <div className="p-2 md:p-6 max-w-2xl mx-auto">
      <h2 className="text-lg font-bold mb-3 text-center">Document Management</h2>

      <div className="flex gap-2 justify-center mb-4">
        <button onClick={() => setTab('general')} className={`px-4 py-2 rounded-full transition ${tab === 'general' ? 'bg-blue-600 text-white shadow' : 'bg-gray-100'}`}>General</button>
        <button onClick={() => setTab('student')} className={`px-4 py-2 rounded-full transition ${tab === 'student' ? 'bg-blue-600 text-white shadow' : 'bg-gray-100'}`}>By student</button>
        <button onClick={() => setTab('teacher')} className={`px-4 py-2 rounded-full transition ${tab === 'teacher' ? 'bg-blue-600 text-white shadow' : 'bg-gray-100'}`}>By teacher</button>
      </div>

      {/* GENERAL */}
      {tab === 'general' && (
        <div className="bg-white rounded-lg p-3 shadow mb-6">
          <form onSubmit={handleGeneralUpload} className="flex flex-col sm:flex-row gap-2 items-center mb-4 text-sm">
            <input type="file" name="file" required className="border border-gray-300 rounded px-2 py-1 flex-1 text-sm" />
            <input type="text" name="doc_type" placeholder="Document type" required className="border border-gray-300 rounded px-2 py-1 flex-1 text-sm" />
            <button type="submit" disabled={uploading} className={`px-4 py-1 rounded-full bg-blue-500 text-white font-medium transition hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300 text-sm ${uploading ? 'opacity-60 cursor-not-allowed' : ''}`}>
              {uploading ? 'Uploading...' : 'Upload'}
            </button>
          </form>

          <div className="overflow-x-auto">
            <table className="min-w-full text-xs border border-gray-300 rounded">
              <thead className="bg-gray-100">
                <tr>
                  <th className="p-2">Type</th>
                  <th className="p-2">File</th>
                  <th className="p-2">Date</th>
                  <th className="p-2">Actions</th>
                </tr>
              </thead>
              <tbody>
                {generalDocs.map(doc => (
                  <tr key={doc.id} className="border-t">
                    <td className="p-2">{doc.doc_type}</td>
                    <td className="p-2">
                      <button onClick={() => handleDownload(doc.id, doc.file_path.split('/').pop())} className="text-blue-700 underline font-medium">Download</button>
                    </td>
                    <td className="p-2">{fmtDate(doc.uploaded_at)}</td>
                    <td className="p-2">
                      <button onClick={() => handleGeneralDelete(doc.id)} className="text-red-500 hover:underline">Delete</button>
                    </td>
                  </tr>
                ))}
                {generalDocs.length === 0 && (
                  <tr><td colSpan={4} className="text-center text-gray-400 py-4">No general documents</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* BY STUDENT */}
      {tab === 'student' && (
        <div className="bg-white rounded-lg p-3 shadow">
          <select
            value={selectedStudent}
            onChange={e => { setSelectedStudent(e.target.value); fetchStudentDocs(e.target.value); }}
            className="border p-2 rounded mb-3 w-full"
          >
            <option value="">-- Select Student --</option>
			{students
			  .slice()
			  .sort((a, b) =>
			    (a.last_name || '').localeCompare(b.last_name || '', 'sr', { sensitivity: 'base' }) ||
			    (a.first_name || '').localeCompare(b.first_name || '', 'sr', { sensitivity: 'base' })
			  )
			  .map(s => (
			    <option key={s.id} value={s.id}>
			      {(s.last_name || '') + ', ' + (s.first_name || '')}
			    </option>
			  ))}
            
          </select>

          {selectedStudent && (
            <>
              <form onSubmit={handleStudentUpload} className="flex flex-col sm:flex-row gap-2 items-center my-2 text-sm">
                <input type="file" name="file" required className="border border-gray-300 rounded px-2 py-1 flex-1 text-sm" />
                <input type="text" name="doc_type" placeholder="Document type" required className="border border-gray-300 rounded px-2 py-1 flex-1 text-sm" />
                <button type="submit" disabled={uploading} className={`px-4 py-1 rounded-full bg-blue-500 text-white font-medium transition hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300 text-sm ${uploading ? 'opacity-60 cursor-not-allowed' : ''}`}>
                  {uploading ? 'Uploading...' : 'Upload'}
                </button>
              </form>

              <div className="overflow-x-auto">
                <table className="min-w-full text-xs border border-gray-300 rounded">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="p-2">Type</th>
                      <th className="p-2">File</th>
                      <th className="p-2">Date</th>
                      <th className="p-2">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {studentDocs.map(doc => (
                      <tr key={doc.id} className="border-t">
                        <td className="p-2">{doc.doc_type}</td>
                        <td className="p-2">
                          <button onClick={() => handleDownload(doc.id, doc.file_path.split('/').pop())} className="text-blue-700 underline font-medium">Download</button>
                        </td>
                        <td className="p-2">{fmtDate(doc.uploaded_at)}</td>
                        <td className="p-2">
                          <button onClick={() => handleStudentDelete(selectedStudent, doc.id)} className="text-red-500 hover:underline">Delete</button>
                        </td>
                      </tr>
                    ))}
                    {studentDocs.length === 0 && (
                      <tr><td colSpan={4} className="text-center text-gray-400 py-4">No documents for student</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      )}

      {/* BY TEACHER (NOVO) */}
      {tab === 'teacher' && (
        <div className="bg-white rounded-lg p-3 shadow">
          <select
            value={selectedTeacher}
            onChange={e => { setSelectedTeacher(e.target.value); fetchTeacherDocs(e.target.value); }}
            className="border p-2 rounded mb-3 w-full"
          >
            <option value="">-- Select Teacher --</option>
            {teachers.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>

          {selectedTeacher && (
            <>
              <form onSubmit={handleTeacherUpload} className="flex flex-col sm:flex-row gap-2 items-center my-2 text-sm">
                <input type="file" name="file" required className="border border-gray-300 rounded px-2 py-1 flex-1 text-sm" />
                <input type="text" name="doc_type" placeholder="Document type" required className="border border-gray-300 rounded px-2 py-1 flex-1 text-sm" />
                <button type="submit" disabled={uploading} className={`px-4 py-1 rounded-full bg-blue-500 text-white font-medium transition hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300 text-sm ${uploading ? 'opacity-60 cursor-not-allowed' : ''}`}>
                  {uploading ? 'Uploading...' : 'Upload'}
                </button>
              </form>

              <div className="overflow-x-auto">
                <table className="min-w-full text-xs border border-gray-300 rounded">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="p-2">Type</th>
                      <th className="p-2">File</th>
                      <th className="p-2">Date</th>
                      <th className="p-2">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {teacherDocs.map(doc => (
                      <tr key={doc.id} className="border-t">
                        <td className="p-2">{doc.doc_type}</td>
                        <td className="p-2">
                          <button onClick={() => handleDownload(doc.id, doc.file_path.split('/').pop())} className="text-blue-700 underline font-medium">Download</button>
                        </td>
                        <td className="p-2">{fmtDate(doc.uploaded_at)}</td>
                        <td className="p-2">
                          <button onClick={() => handleTeacherDelete(selectedTeacher, doc.id)} className="text-red-500 hover:underline">Delete</button>
                        </td>
                      </tr>
                    ))}
                    {teacherDocs.length === 0 && (
                      <tr><td colSpan={4} className="text-center text-gray-400 py-4">No documents for teacher</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default AdminDocuments;



